import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const PriceTotalContainer = css`
  padding: ${wplToken('space.250')} 0 ${wplToken('space.400')} 0;

  background-color: #f2f7fe;
`;

export const BasePriceContainer = css`
  font-family: var(--bxp-charlie-display-font-family);
  display: flex;
  justify-content: center;
`;

export const FormattedPriceDisplay = css`
  align-self: center;
  font-size: 3.375rem;
  font-weight: 500;

  span {
    font-size: 1rem;
  }
`;

export const EstimatedCostContainer = css`
  display: flex;
  justify-content: center;
  margin-top: 0.3125rem;
`;

export const TaxNotIncludedContainer = css`
  margin-top: 0.3125rem;
  display: flex;
  font-weight: 400;
  font-size: 0.875rem;
  justify-content: center;
  color: ${getColor('n400')};
`;

export const ContactSalesContainer = css`
  margin-top: 1.875rem;
  display: flex;
  justify-content: center;

  > a {
    :hover,
    :focus {
      color: white;
      text-decoration: none;
    }
  }
`;
